/* The Whole Story – product page (sections/twst-main-product.liquid):
   gallery thumbnails, size picker → variant id / URL / image, copy discount code.
   Add to cart itself is Dawn's <product-form>. */
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    const gallery = root.querySelector('[data-twst-gallery]');
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    const swiper = () => gallery && gallery.swiper;

    const markThumb = (index) => thumbs.forEach((t, i) => t.setAttribute('aria-current', i === index ? 'true' : 'false'));

    const bindSwiper = () => {
      const sw = swiper();
      if (!sw) return false;
      sw.on('slideChange', () => markThumb(sw.activeIndex));
      return true;
    };
    if (!bindSwiper()) window.addEventListener('load', bindSwiper, { once: true });

    thumbs.forEach((t) =>
      t.addEventListener('click', () => {
        const index = Number(t.dataset.thumb);
        if (swiper()) swiper().slideTo(index);
        markThumb(index);
      })
    );

    // Size picker
    const idInput = root.querySelector('form input[name="id"]');
    const buy = root.querySelector('.twst-pmain__buy');
    // the sticky bar is rendered right after .twst-pmain (outside its stacking context)
    const sticky = document.getElementById(`TwstSticky-${root.dataset.section}`);
    const stickyBtn = sticky && sticky.querySelector('button');
    const wasEl = root.querySelector('[data-twst-price-was]');
    const offEl = root.querySelector('[data-twst-price-off]');
    const stickySize = sticky && sticky.querySelector('[data-twst-sticky-size]');
    root.querySelectorAll('.twst-size input').forEach((radio) =>
      radio.addEventListener('change', () => {
        if (idInput) idInput.value = radio.value;
        const available = radio.dataset.available === 'true';
        if (buy) {
          buy.disabled = !available;
          buy.querySelector('span').textContent = available ? buy.dataset.label : buy.dataset.soldout;
        }
        if (stickyBtn && buy) {
          stickyBtn.disabled = !available;
          stickyBtn.textContent = available ? buy.dataset.label : buy.dataset.soldout;
        }

        // Price block + sticky bar
        [root, sticky].forEach((scope) =>
          scope?.querySelectorAll('[data-twst-price-now]').forEach((el) => (el.textContent = radio.dataset.price || ''))
        );
        const onSale = Boolean(radio.dataset.compare);
        if (wasEl) {
          wasEl.textContent = radio.dataset.compare || '';
          wasEl.hidden = !onSale;
        }
        if (offEl) {
          offEl.textContent = onSale ? `${radio.dataset.off}% OFF` : '';
          offEl.hidden = !onSale;
        }
        if (stickySize) stickySize.textContent = radio.closest('.twst-size')?.querySelector('.twst-size__name')?.textContent || '';
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url.toString());

        const slide = radio.dataset.media && gallery && gallery.querySelector(`[data-media-id="${radio.dataset.media}"]`);
        if (slide && swiper()) swiper().slideTo([...slide.parentElement.children].indexOf(slide));
      })
    );

    // Mobile sticky add to cart: visible while the main button is out of view (and the footer isn't in view)
    // (scroll check, not IntersectionObserver: a fast scroll can jump past the button without an intersection change)
    if (sticky && buy) {
      // first footer-group section (the ribbon) – hide the bar once the footer area scrolls in
      const footer = document.querySelector('.shopify-section-group-footer-group');
      let shown = false;
      let queued = false;
      const update = () => {
        queued = false;
        const passedBuy = buy.getBoundingClientRect().bottom < 0;
        const atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        const show = passedBuy && !atFooter;
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      const queue = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      };
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
    }

    // Reviews app badge (Judge.me) → Figma text "4.8/5 · 126 Reviews", built from the badge's own data.
    // The app can re-render the badge after load, so it is re-applied on every change.
    const reviews = root.querySelector('.twst-pmain__app');
    if (reviews) {
      const formatBadge = () => {
        reviews.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
          const text = badge.querySelector('.jdgm-prev-badge__text');
          const count = parseInt(badge.dataset.numberOfReviews, 10);
          const average = parseFloat(badge.dataset.averageRating);
          if (!text || !count || Number.isNaN(average)) return; // no reviews yet – keep the app's own text
          const label = count === 1 ? reviews.dataset.twstReviewsOne : reviews.dataset.twstReviewsMany;
          const value = `${average.toFixed(1)}/5 · ${count} ${label}`;
          if (text.textContent !== value) text.textContent = value;
        });
      };
      formatBadge();
      new MutationObserver(formatBadge).observe(reviews, { childList: true, subtree: true, characterData: true });
    }

    // Copy discount code (one button per coupon)
    root.querySelectorAll('[data-copy]').forEach((copy) => {
      copy.addEventListener('click', async () => {
        const status = copy.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText(copy.dataset.copy);
          if (status) status.textContent = copy.dataset.copied || 'Copied';
          copy.classList.add('is-copied');
          setTimeout(() => copy.classList.remove('is-copied'), 1500);
        } catch (e) {
          /* clipboard blocked – nothing else to do */
        }
      });
    });
  };

  const boot = () => document.querySelectorAll('[data-twst-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-twst-product]').forEach(init));
})();
